/**
 * Simple energy conversion functions
 */
function convertKwhToMwh(kWh: number): number {
  if (typeof kWh !== "number" || isNaN(kWh)) return 0;
  return kWh / 1000;
}

export default convertKwhToMwh;
export { convertKwhToMwh };

export function convertMwhToKwh(MWh: number): number {
  if (typeof MWh !== "number" || isNaN(MWh)) return 0;
  return MWh * 1000;
}

export function roundNumber(value: number): number {
  if (typeof value !== "number" || isNaN(value)) return 0;
  return Math.round(value);
}
